import React from "react";

const CallbirdComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default CallbirdComponent;
